exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-group[data-v-23613e0e]{\n  text-align: center;\n}\n.form-control.half[data-v-23613e0e]{\n  display: inline-block;\n  width: 231.15px;\n}\n.room-select[data-v-23613e0e]{\n  border: 2px solid cornflowerblue;\n}\n", ""]);

// exports
